<template>
  <div class="row">
    <div class="col-sm-6 col-12 mb-2 mb-sm-0 pr-sm-1">
      <input
        v-model="newDoctorFirst"
        type="text"
        class="form-control form-control-lg form-control-xl d-block"
        placeholder="First Name"
        v-validate="'required'"
        name="doctorFirstName"
        data-vv-as="first name"
        @changed="nameChanged"
      />
      <span v-if="errors.has('doctorFirstName', 'referral-form')" class="invalid-feedback d-block">{{
        errors.first('doctorFirstName', 'referral-form')
      }}</span>
    </div>
    <div class="col pl-sm-1">
      <input
        v-model="newDoctorLast"
        type="text"
        class="form-control form-control-lg form-control-xl d-block"
        placeholder="Last Name"
        v-validate="'required'"
        name="doctorLastName"
        data-vv-as="last name"
        @change="nameChanged"
      />
      <span v-if="errors.has('doctorLastName', 'referral-form')" class="invalid-feedback d-block">{{
        errors.first('doctorLastName', 'referral-form')
      }}</span>
    </div>
    <div v-if="showAddButton" class="col-3 text-right">
      <button @click="addNewDoctor" class="btn btn-primary btn-xl" :disabled="isAddingDoctor">
        <font-awesome-icon icon="spinner-third" v-if="isAddingDoctor" spin /><span v-else>Add</span>
      </button>
    </div>
  </div>
</template>

<script>
import * as Sentry from '@sentry/vue'

export default {
  props: {
    showAddButton: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      isAddingDoctor: false,
      newDoctorFirst: null,
      newDoctorLast: null,
    }
  },
  $_veeValidate: {
    validator: 'new', // give me my own validator scope.
  },
  methods: {
    async nameChanged(e) {
      e.preventDefault()
      const _this = this
      const valid = await this.$validator.validate('*', null, { silent: true })
      if (!valid) return

      // this is just for the public form, we want to save this locally in state so that the PublicReferral component
      // can then promotePublicUser
      this.$emit('added', {
        first_name: this.newDoctorFirst,
        last_name: this.newDoctorLast,
        is_doctor: true,
      })
    },
    async addNewDoctor(e) {
      e.preventDefault()
      const _this = this
      const valid = await this.$validator.validate()
      if (!valid) return
      let email = `${this.newDoctorFirst}.${this.newDoctorLast}+${new Date().getTime()}_${Math.random()
        .toString(36)
        .substr(2, 5)}_2@dentist.refera.io`
        .toLowerCase()
        .replace(/\s/g, '')
      _this.isAddingDoctor = true
      //TODO: Improve this and handle the duplicate handling server side, for now rely on timestamp
      return this.$store
        .dispatch('users/save', {
          email,
          first_name: this.newDoctorFirst,
          last_name: this.newDoctorLast,
          is_doctor: true,
        })
        .then((data) => {
          _this.$helpers.success('Doctor added')
          _this.newDoctorFirst = ''
          _this.newDoctorLast = ''
          this.$emit('added', data)
          return true
        })
        .catch((err) => {
          _this.$exception(err)
          _this.$helpers.error('Failed to add doctor')
        })
        .finally(() => {
          _this.isAddingDoctor = false
        })
    },
  },
}
</script>

<style>
</style>